export enum Sorting {
  None,
  Name,
  Date,
  Price
}
